import { removeScript } from 'utils/script';

export const htmlStringToNode = (html: string) => {
  // Create a container, set its inner HTML
  const container = document.createElement('div');
  container.innerHTML = removeScript(html);

  // Create a node, append the container to it
  const fragment = document.createDocumentFragment();
  fragment.append(container);

  // Transfer all children from the container to the node, then remove container
  while (container.firstChild) fragment.append(container.firstChild);
  fragment.removeChild(container);

  // Return extracted children as a document fragment node
  return fragment;
};
